import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { getSpacing } from '../../const/spacing';
import { copyTextToClipboard } from '../../helpers/copyTextToClipboard';
import { Icon } from '../Icon/Icon';
import { getIconColor } from '../Icon/iconConst';
import { PlainButton } from '../PlainButton/PlainButton';
import { Text } from '../Text/Text';
import { FlexContainer } from '../layout/FlexContainer';
const ICON_COLOR = getIconColor('greyLight');
const HOVER_ICON_COLOR = getIconColor('action');
const StyledIconWrapper = styled('div', (p) => ({
    color: ICON_COLOR,
    padding: getSpacing('1/2'),
    ...(p.$hasHover && { ':hover': { color: HOVER_ICON_COLOR } }),
}));
export const CopyableText = ({ children, testId, onCopySuccess, onCopyError, hasHover = false, ...textProps }) => {
    const handleClick = (event) => {
        event.stopPropagation();
        copyTextToClipboard({ text: children, onCopySuccess, onCopyError });
    };
    const maybeIconColorOverride = hasHover ? 'currentColor' : undefined;
    return (_jsxs(FlexContainer, { verticalAlign: 'center', gap: '1/2', children: [_jsx(Text, { ...textProps, children: children }), _jsx(PlainButton, { testId: testId, onClick: handleClick, children: _jsx(StyledIconWrapper, { $hasHover: hasHover, children: _jsx(Icon, { name: 'OutlineContentCopy', size: 'small', color: 'greyLight', colorOverride: maybeIconColorOverride }) }) })] }));
};
